import { createAction, handleActions } from 'redux-actions';

// ACTION TYPES
const ATUALIZAR_STORE = `${process.env.PUBLIC_URL}/ITEMMENU/ATUALIZAR_STORE`;
const ITEMMENU_CONSULTAR_POR_ID = `${process.env.PUBLIC_URL}/ITEMMENU/CONSULTAR`;
const ITEMMENU_CONSULTAR_POR_FILTRO = `${process.env.PUBLIC_URL}/ITEMMENU/CONSULTAR_POR`;
const ITEMMENU_LIMPAR = `${process.env.PUBLIC_URL}/ITEMMENU/LIMPAR`;
const ITEMMENU_REMOVER = `${process.env.PUBLIC_URL}/ITEMMENU/REMOVER`;
const ITEMMENU_SALVAR = `${process.env.PUBLIC_URL}/ITEMMENU/SALVAR`;
const ITEMMENU_PROXIMA_ORDEM = `${process.env.PUBLIC_URL}/ITEMMENU/PROXIMO`;
const ITEMMENU_CONSULTAR_PUBLICADOS = `${process.env.PUBLIC_URL}/ITEMMENU/PUBLICADOS`;
const ATUALIZAR_ITEM_MENU = `${process.env.PUBLIC_URL}/ITEMMENU/ATUALIZAR_ITEM_MENU`;
const ITEMMENU_CONSULTAR_DINAMICO = `${process.env.PUBLIC_URL}/ITEMMENU/CONSULTAR_MENU_DINAMICO`;

export const types = {
	ATUALIZAR_STORE,
	ITEMMENU_CONSULTAR_POR_ID,
	ITEMMENU_CONSULTAR_POR_FILTRO,
	ITEMMENU_CONSULTAR_PUBLICADOS,
	ITEMMENU_LIMPAR,
	ITEMMENU_REMOVER,
	ITEMMENU_SALVAR,
	ITEMMENU_PROXIMA_ORDEM,
	ATUALIZAR_ITEM_MENU,
	ITEMMENU_CONSULTAR_DINAMICO
};

// ACTIONS
const atualizarStore = createAction(ATUALIZAR_STORE);
const atualizarItemMenu = createAction(ATUALIZAR_ITEM_MENU);
const consultarPorCodigo = createAction(ITEMMENU_CONSULTAR_POR_ID);
const consultarMenuDinamico = createAction(ITEMMENU_CONSULTAR_DINAMICO);
const consultarProximaOrdem = createAction(ITEMMENU_PROXIMA_ORDEM);
const consultarPorFiltro = createAction(ITEMMENU_CONSULTAR_POR_FILTRO);
const limpar = createAction(ITEMMENU_LIMPAR);
const remover = createAction(ITEMMENU_REMOVER);
const salvar = createAction(ITEMMENU_SALVAR);
const consultarItensMenuPublicados = createAction(ITEMMENU_CONSULTAR_PUBLICADOS);

export const actions = {
	atualizarStore,
	consultarPorCodigo,
	consultarPorFiltro,
	consultarProximaOrdem,
	limpar,
	remover,
	salvar,
	consultarItensMenuPublicados,
	atualizarItemMenu,
	consultarMenuDinamico
};

// INITIAL STATE
const initialState = {};

// REDUCERS
const reducer = handleActions(
	{
		[ATUALIZAR_STORE]: (state, action) => {
			return { ...state, ...action.payload };
		}
	},
	initialState
);

export default reducer;

// SELECTORS
const getItensMenu = state => {
	return state.itensMenu.lista || {};
};

const getListaItemMenu = state => {
	return getItensMenu(state).list || [];
};

const getListaMenus = state => {
	return state.itensMenu.menus || [];
};

const getCurrentPage = state => {
	return getItensMenu(state).page || 0;
};

const getTotalItensMenu = state => {
	return getItensMenu(state).total || 0;
};

const getTotalPaginas = state => {
	return getItensMenu(state).pages || 0;
};

const getItemMenu = state => {
	return state.itensMenu.itemMenu || {};
};

const getItemMenuDinamico = state => {
	return state.itensMenu.itemMenuDinamico || {};
};

export const selectors = {
	getListaItemMenu,
	getCurrentPage,
	getListaMenus,
	getTotalItensMenu,
	getTotalPaginas,
	getItemMenu,
	getItemMenuDinamico	
};
